import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { SubGroupDto,GroupDto, DivestmentStatusDto } from '@cradua/data';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';


@Component({
  selector: 'cradua-subgroup',
  templateUrl: './subgroup.component.html',
  styleUrls: ['./subgroup.component.scss']
})
export class SubGroupComponent implements OnChanges {

  @Input() subgroups: SubGroupDto[];
  @Input() groups: GroupDto[];
  @Input() divestmentstatuss: DivestmentStatusDto[]
  subgroupForm: FormGroup;
  subgroupFormArray: FormGroup;
  control = new FormControl();
  @Input() routeAnimationsElements: any;
  @Output() changeEmit = new EventEmitter<SubGroupDto>();
  @Output() deleteEvent = new EventEmitter<any>();

  filteredDelete: Array<any> = [];
  filteredSubGroup: Array<any> = [];
  status: boolean;
  selectedSubGroupId: any;
  selectedIndex = null;

  constructor(private fb: FormBuilder) {}

  ngOnChanges() {
    this.createSubGroupForm();
  }

  createSubGroupForm() {
    this.subgroupFormArray = this.fb.group({ SubGroups: this.fb.array([]) });
    this.subgroupForm = this.fb.group({
        SubGroupName: ['', Validators.required],
        SubGroupCode: ['', Validators.required],
        GroupId: this.selectedSubGroupId,
        DivestmentStatusId: ['', Validators.required],
        id: null
    });
  }


  // method to display companies
  setSubGroup() {
    const control = this.subgroupFormArray.controls.SubGroups as FormArray;
    this.filteredSubGroup.forEach((e) => {
      control.push(
        this.fb.group({
            SubGroupName: e.SubGroupName,
            SubGroupCode: e.SubGroupCode,
            GroupId: e.GroupId,
            DivestmentStatusId: e.DivestmentStatusId,
          id: e.id,
        })
      );
    });
  }

   // method to add Company
   addSubGroup(subgroup: SubGroupDto) {
    console.log('subgroup');
    const control = this.subgroupFormArray.controls.SubGroups as FormArray;
    control.insert(
      0,
      this.fb.group({
        SubGroupName: subgroup.SubGroupName,
        GroupId: this.selectedSubGroupId,
        SubGroupCode: subgroup.SubGroupCode,
        DivestmentStatusId: subgroup.DivestmentStatusId,

      })
    );
  }


  // method to reset form array after selection
  clearFormArray = (formArray: FormArray) => {
    const control = this.subgroupFormArray.controls.SubGroups as FormArray;
    while (formArray.length !== 0) {
      control.removeAt(0);
    }
  };

  // method to filter country
  selectGroup(event: string) {
    this.filteredSubGroup = this.subgroups.filter((s) => s.GroupId === event);
    this.selectedSubGroupId = event;
    const control = this.subgroupFormArray.controls.SubGroups as FormArray;

    if (this.filteredSubGroup.length > 0) {
      this.status = true;
      this.clearFormArray(control);
      this.setSubGroup();
    } else {
      this.status = true;
      this.clearFormArray(control);
    }
  }

  print(event: any) {
    window.print();
  }
  // method to delete company from arrary list
  deleteSubGroup(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.subgroupFormArray.controls.SubGroups as FormArray;
        control.removeAt(index);
        for (let i = 0; i < this.subgroups.length; i++) {
          if (i === index) {
            if (value.id !== null) {
              this.filteredDelete.push(this.subgroups[i].id);
            }
          }
        }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }


  addNew(formValue: SubGroupDto) {
    if(this.subgroupForm.invalid) {
   return Swal.fire(
      'Warning!',
      'Please, you cannot add blank field',
      'warning'
    );
    }
    if(this.selectedIndex != null) {

      this.subgroupFormArray.get('SubGroups')['controls'][this.selectedIndex].patchValue(formValue);
    } else {
      this.addSubGroup(formValue);
    }
    this.selectedIndex = null;
    this.subgroupForm.reset()
  }

  onEdit(index, value: SubGroupDto) {
    this.selectedIndex = index;
    this.subgroupForm.patchValue(value);
  }

  onClearForm() {
    this.selectedIndex = null;
    this.subgroupForm.reset();
  }


  getDivestmentStatusName(id: string) {
    const found = this.divestmentstatuss.find(acc => acc.id === id);
    // console.log('log ', id)
    return found ? found.DivestmentStatusName : '';
  }

  onSubmit(formValue: any) {
    formValue.type = 'subgroup';
    this.changeEmit.emit(formValue);
    if (this.filteredDelete.length > 0) {
      this.filteredDelete.unshift('subgroup');
      this.deleteEvent.emit(this.filteredDelete);
    }
  }

}
